import { getConfig } from '../common/env-config';
import { refreshToken } from '../common/refresh-token-repo';
const { baseUrl } = getConfig();

export const getCampaignsList = async (setCampaignList, setTotalCampaigns, setIsLoading, pageNo, pageSize) => {
  try {
    const url = `${baseUrl}/campaign/v1/live`;
    const response = await fetch(url, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem("accessToken")}`,
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify({ pageNo, pageSize })
    });
    const data = await response.json();
    if (response.ok) {
      setCampaignList(data.campaigns);
      setTotalCampaigns(data.totalCampaigns);
    } else if (response.status === 499) {
      refreshToken();
    } else {
      console.error('Error fetching live campaigns:', data.message);
    }
  } catch (error) {
    console.error('Error fetching live campaigns:', error);
  } finally {
    setIsLoading(false);
  }
};

export const downloadFiles = async (fileId, fileName) => {
  try {
    const response = await fetch(`${baseUrl}/campaign/file/download/${fileId}/${fileName}`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem("accessToken")}`
      }
    });
    if (!response.ok) {
      throw new Error('Failed to download file');
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  } catch (error) {
    console.error('Error while downloading file');
  }
};

export const getCampaign = async (campaignId, setCampaign) => {
  try {
    const response = await fetch(`${baseUrl}/campaign/${campaignId}`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem("accessToken")}`
      }
    });
    const data = await response.json();
    if (response.ok) {
      setCampaign(data);
      return data;
    } else if (response.status === 499) {
      refreshToken();
    } else {
      console.error('Error fetching campaign:', data.message);
      return null;
    }
  } catch (error) {
    console.error('Error fetching campaign:', error);
  }
};

export const getAcceptedApplicationCount = async (campaignId, setAcceptApplicationCount) => {
  const response = await fetch(`${baseUrl}/admin/accepted-application-count/${campaignId}`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${localStorage.getItem("accessToken")}`
    }
  });

  const data = await response.json();
  if (response.ok) {
    setAcceptApplicationCount(data);
  } else if (response.status === 499) {
    refreshToken();
  }
}

export const fetchCampaignApplication = async (setLoading, campaignId, currentApplicationsPage, rowsPerPage,
  setTotalResults, setApiFailed, setTotalPages, setCreators, followersFilterValue) => {
  try {
    setLoading(true);
    let filters = {
      campaignId: campaignId,
      pageNo: currentApplicationsPage,
      pageSize: rowsPerPage,
    };

    if (followersFilterValue.min != null && followersFilterValue.max != null &&
      followersFilterValue.min !== '' && followersFilterValue.max !== '') {
      filters.followersRange = followersFilterValue
    }
    const response = await fetch(`${baseUrl}/campaign/v1/accepted-applicants`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem("accessToken")}`
      },
      body: JSON.stringify(filters)
    });

    const data = await response.json();
    if (response.ok) {
      const transformedResponse = {
        totalResults: data.totalResults,
        creators: data.creators.map(item => ({
          instaId: item.instaId,
          instaHandle: item.instaHandle,
          instaFullName: item.instaFullName,
          followersCount: item.followersCount,
          mediaCount: item.mediaCount,
          totalLikes: item.totalLikes,
          totalComments: item.totalComments,
          engagement: item.engagement,
          engagementRate: item.engagementRate,
          noOfPost: item.noOfPost,
          profilePictureId: item.profilePictureId,
          bio: item.bio,
          creatorRates: item.creatorRates,
          creatorScore: item.creatorScore,
          avgLike: item.avgLike,
          avgComment: item.avgComment,
          creatorId: item.creatorId,
          creatorFullName: item.creatorFullName,
          applicationStatus: item.applicationStatus,
          appliedStatus: item.appliedStatus,
          appliedDate: item.appliedDate,
          actionPerformBy: {
            userId: item.actionPerformBy != null ? item.actionPerformBy.userId : null,
            fullName: item.actionPerformBy != null ? item.actionPerformBy.fullName : null
          },
          acceptDate: item.acceptDate,
          notificationSent: item.notificationSent,
          price: item.price,
          videoOnDate: item.videoOnDate,
          liveDate: item.liveDate,
          type: item.type,
          postLink: item.postLink,
          latestVersion: item.latestVersion,
          latestVideoUrl: item.latestVideoUrl,
          phoneNumber: item.phoneNumber,
          approvedByClient: item.approvedByClient
        }))
      };
      setTotalResults(transformedResponse.totalResults);
      setApiFailed(transformedResponse.creators.length === 0);
      setTotalPages(Math.ceil(transformedResponse.totalResults / rowsPerPage));
      setCreators(transformedResponse.creators);
    } else if (response.status === 499) {
      refreshToken();
    } else {
      console.error('Error fetching campaign application:', data.message);
      setApiFailed(true);
    }
    setLoading(false);
  } catch (error) {
    console.error('Error fetching campaign application:', error);
    setApiFailed(true);
    setLoading(false);
  }
};

export const acceptCampaignApplication = async (campaignId, creatorId, acceptStatus, setAccept) => {
  const response = await fetch(`${baseUrl}/admin/accept-campaign-application?campaignId=${campaignId}&creatorId=${creatorId}&acceptStatus=${acceptStatus}`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${localStorage.getItem("accessToken")}`
    }
  });

  const data = await response.json();
  if (response.ok) {
    setAccept(Math.random().toString(36).substring(7));
  } else if (response.status === 499) {
    refreshToken();
  } else {
    console.error('Failed To Apply For Campaign :', data.message);
  }
};

export const exportCampaignApplication = async (campaignId, fitStatus, maybeStatus, notFitStatus) => {
  try {
    let filters = {
      campaignId: campaignId,
      appliedDate: true,
      fitStatus: fitStatus,
      maybeStatus: maybeStatus,
      notFitStatus: notFitStatus
    };
    const response = await fetch(`${baseUrl}/admin/export-applications`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem("accessToken")}`
      },
      body: JSON.stringify(filters)
    });
    if (!response.ok) {
      console.error('Failed to export campagn application');
    } else {
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');

      link.href = url;
      link.setAttribute('download', "campaign-applications.xlsx");
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    }
  } catch (error) {
    console.error('Failed to export campagn application');
  }
};

export const addCreatorRate = async (campaignId, paymentRequest, setRateAdded, setPaymentRequest) => {
  try {
    const { creatorId, price, videoOnDate, liveDate } = paymentRequest;
    const response = await fetch(`${baseUrl}/campaign/v1/${campaignId}/payment-due-requests`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${localStorage.getItem("accessToken")}`
      },
      body: JSON.stringify({ creatorId, price, videoOnDate, liveDate })
    });

    const data = await response.json();
    if (response.ok) {
      setRateAdded(Math.random().toString(36).substring(7));
    } else if (response.status === 499) {
      refreshToken();
    } else {
      console.error('Error to add creator rate:', data.message);
    }
    setPaymentRequest({ creatorId: "", price: "", videoOnDate: "", liveDate: "" });
  } catch (error) {
    console.error('Error to add creator rate:', error);
  }
};

export const getCampaignApplicantCreatorProfile = async (campaignId, creatorId, setApplicantDetails, setLoading) => {
  const response = await fetch(`${baseUrl}/campaign/v1/${campaignId}/${creatorId}/applicant-profile`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${localStorage.getItem("accessToken")}`
    }
  });
  const data = await response.json();
  if (response.ok) {
    setApplicantDetails(data.applicant);
  } else if (response.status === 499) {
    refreshToken();
  } else {
    console.error("Error occure while fetching applicant detail");
  }
  if (setLoading != null) {
    setLoading(false);
  }
}

export const addAcceptedCreator = async (campaignId, creatorPhoneNumber, setCreatorAdded) => {
  try {
    const response = await fetch(`${baseUrl}/campaign/v1/add-applicants`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${localStorage.getItem("accessToken")}`
      },
      body: JSON.stringify({ campaignId, creatorPhoneNumber })
    });

    const data = await response.json();
    if (response.ok) {
      setCreatorAdded(Math.random().toString(36).substring(7));
      return { success: true };
    } else if (response.status === 499) {
      refreshToken();
      return { error: 'Session expired. Please try again.' };
    } else {
      console.error('Error to add accepted applicant error:', data.message);
      return { error: data.message || 'Failed to add creator' };
    }
  } catch (error) {
    console.error('Error to add accepted applicant error:', error);
    return { error: 'Network error occurred. Please try again.' };
  }
};

export const removeAcceptedCreator = async (campaignId, creatorPhoneNumber, setCreatorAdded) => {
  try {
    const response = await fetch(`${baseUrl}/campaign/v1/remove-applicants`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${localStorage.getItem("accessToken")}`
      },
      body: JSON.stringify({ campaignId, creatorPhoneNumber })
    });

    const data = await response.json();
    if (response.ok) {
      setCreatorAdded(Math.random().toString(36).substring(7));
      return { success: true };
    } else if (response.status === 499) {
      refreshToken();
      return { error: 'Session expired. Please try again.' };
    } else {
      console.error('Error to remove accepted applicant error:', data.message);
      return { error: data.message || 'Failed to remove creator' };
    }
  } catch (error) {
    console.error('Error to remove accepted applicant error:', error);
    return { error: 'Network error occurred. Please try again.' };
  }
};

export const addPostLink = async (campaignId, postLink, creatorId, setRateAdded, handleClose, setError, setLoading) => {
  try {
    const response = await fetch(`${baseUrl}/campaign/v1/${campaignId}/add-post-link`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${localStorage.getItem("accessToken")}`
      },
      body: JSON.stringify({ creatorId, postLink })
    });

    const data = await response.json();
    if (response.ok) {
      setRateAdded(Math.random().toString(36).substring(7));
      handleClose();
      setLoading(false);
    } else if (response.status === 499) {
      refreshToken();
      setLoading(false);
    } else {
      console.error('Error to add post link:', data.message);
      setError(data.message);
      setLoading(false);
    }
  } catch (error) {
    console.error('Error to add post link:', error);
    setError(error);
    setLoading(false);
  }
};

export const addCreatorVideoUrl = async (campaignId, addVideoUrl, setVideoLinkError, setRateAdded, setOpenVideoUrl, setAddVideoUrl) => {
  try {
    const { creatorId, videoLink, oyeCreatorRemark } = addVideoUrl;
    const response = await fetch(`${baseUrl}/campaign/v1/${campaignId}/add-video-link`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${localStorage.getItem("accessToken")}`
      },
      body: JSON.stringify({ creatorId, videoLink, oyeCreatorRemark })
    });

    const data = await response.json();
    if (response.ok) {
      setRateAdded(Math.random().toString(36).substring(7));
      setOpenVideoUrl(false);
      setAddVideoUrl({ creatorId: "", videoLink: "", oyeCreatorRemark: "", latestVersion: "" });
    } else if (response.status === 499) {
      refreshToken();
    } else {
      console.error('Error to add video url:', data.message);
      setVideoLinkError(data.message);
    }
  } catch (error) {
    console.error('Error to add video url:', error);
    setVideoLinkError(error);
  }
};

export const getVideoVersionHistory = async (campaignId, creatorId, setVideoVersionHistory) => {
  try {
    const response = await fetch(`${baseUrl}/campaign/v1/${campaignId}/video-versions`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${localStorage.getItem("accessToken")}`
      },
      body: JSON.stringify({ creatorId })
    });

    const data = await response.json();
    if (response.ok) {
      setVideoVersionHistory(data.videoVersionHistory);
    } else if (response.status === 499) {
      refreshToken();
    } else {
      console.error('Error to get video version history:', data.message);
    }
  } catch (error) {
    console.error('Error to get video version history:', error);
  }
};

export const updateVideoStatus = async (campaignId, creatorId, videoVersion, status) => {
  try {
    const response = await fetch(`${baseUrl}/campaign/v1/${campaignId}/video-status`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${localStorage.getItem("accessToken")}`
      },
      body: JSON.stringify({ creatorId, videoVersion, status })
    });

    const data = await response.json();
    if (response.ok) {
      return { success: true };
    } else if (response.status === 499) {
      refreshToken();
      return { error: 'Session expired. Please try again.' };
    } else {
      console.error('Error to update video version status:', data.message);
      return { error: data.message || 'Failed to remove creator' };
    }
  } catch (error) {
    console.error('Error to update video version status:', error);
    return { error: 'Network error occurred. Please try again.' };
  }
};

export const getVideoHistoryFileUrl = async (fileName) => {
  try {
    const response = await fetch(`${baseUrl}/campaign/v1/download-file`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${localStorage.getItem("accessToken")}`
      },
      body: JSON.stringify({ fileName }),
    });

    if (!response.ok) {
      throw new Error('Failed to fetch file');
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    return url;

  } catch (error) {
    console.error('Error fetching file:', error);
    return null;
  }
};
